import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const advantages = ['Une vision 360° : marketing, business et technologie sous un seul toit', 'Exécution rapide et orientée résultats, pas de bureaucratie', 'Expertise technique réelle combinée à une vision business', 'Pilotage data-driven avec reporting transparent', 'Accompagnement sur-mesure adapté à votre phase de croissance'];
export function ValueProposition() {
  return <section className="py-40 bg-black text-white relative overflow-hidden" data-id="element-130">
      {/* Geometric background accents */}
      <div className="absolute top-40 right-0 w-64 h-64 border border-white/5" data-id="element-131" />
      <div className="absolute bottom-20 left-0 w-48 h-48 border border-white/5" data-id="element-132" />

      <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center mb-20" data-id="element-134">
          <h2 className="text-6xl md:text-7xl font-black mb-6 tracking-tight" data-id="element-135">
            Pourquoi Nexyom ?
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto font-light leading-relaxed" data-id="element-136">
            Ce que les agences classiques et les cabinets IT ne peuvent pas
            faire en même temps.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="space-y-5" data-id="element-137">
          {advantages.map((advantage, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.7,
          delay: index * 0.08,
          ease: [0.16, 1, 0.3, 1]
        }} className="group flex items-start gap-5 p-8 bg-white/5 backdrop-blur-sm border border-white/10 transition-all duration-500 hover:bg-white/10 hover:border-white/20" data-id="element-138">
              <div className="flex-shrink-0 w-10 h-10 bg-blue-500 flex items-center justify-center transition-transform duration-500 group-hover:scale-110" data-id="element-139">
                <CheckIcon className="w-6 h-6 text-white" strokeWidth={2.5} data-id="element-140" />
              </div>
              <p className="text-lg text-gray-300 leading-relaxed font-light pt-1" data-id="element-141">
                {advantage}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}